import ObjectiveCell from '../common/ObjectiveCell';
import FormatChange from '../common/FormatChange';
import { Link } from 'react-router-dom';
import React, { useEffect, useState, useCallback } from 'react';
import { fetchEnhancedMetrics } from '../../api/api';


const formatPrice = (price) => {
  if (!price) return '-';
  return price < 10
    ? `${price.toFixed(3)} €`  // Show 3 decimals for prices < 10
    : `${price.toFixed(2)} €`; // Show 2 decimal for others
};

const StockRow = ({ stock, removeStock, updateObjective, toggleWatchlist ,isRefreshing, refreshState, editStock }) => {
    const [enhancedMetrics, setEnhancedMetrics] = useState(null);
    const [isLoadingMetrics, setIsLoadingMetrics] = useState(false);

    const handleToggleWatchlist = useCallback(
      () => toggleWatchlist(stock.id, stock.watchlist),
      [toggleWatchlist, stock.id, stock.watchlist]
    );

    const handleRemove = useCallback(
      () => removeStock(stock.id),
      [removeStock, stock.id]
    );

    const calculateRatio = () => {
        if (stock.objective === null || stock.objective === undefined) return null;
        if (stock.price === null || stock.price <= 0) return null;
        return (stock.objective / stock.price).toFixed(2);
    };

    const ratio = calculateRatio();
    //const stockWithRatio = { ...stock, ratio };
    //const rowClass = refreshState ? `${refreshState}` : '';

    useEffect(() => {
        const loadMetrics = async () => {
            setIsLoadingMetrics(true);
            try {
                // This now handles BOTH API fetch AND localStorage caching
                const metrics = await fetchEnhancedMetrics(stock.url);
                setEnhancedMetrics(metrics);
            } catch (error) {
                console.error('Failed to load metrics:', error);
                setEnhancedMetrics(null); // Explicitly set null on error
            } finally {
                setIsLoadingMetrics(false);
            }
        };

        loadMetrics();
    }, [stock.url]); // Only dependency is stock.url

    return (
        <tr className={`${refreshState || ''} ${isRefreshing ? 'refreshing' : ''}`}>
            <td>
              <Link to={`/stats?url=${encodeURIComponent(stock.url)}`} className="company-link">
                {stock.name || '-'}
              </Link>
              {stock.isin && <div className="isin-code">{stock.isin}</div>}
            </td>
            <td className="price-cell">{formatPrice(stock.price)}</td>
            <ObjectiveCell
                objective={stock.objective}
                onUpdate={(newObjective) => editStock(stock.id, { objective: newObjective })}
                url={stock.url}
            />
            <td title={`${stock.objective} ÷ ${stock.price}`} style={{ color: ratio > 1 ? 'green' : 'red' }}>{ratio || '-'}</td>
            <td><FormatChange change={stock.daily_change} /></td>
            <td><FormatChange change={stock.five_days_change} /></td>
            <td className="numeric">
                {isLoadingMetrics ? '...' :
                 (enhancedMetrics?.Local_Max_Count_2Y !== undefined ?
                  enhancedMetrics.Local_Max_Count_2Y : 'N/A')}
            </td>
            <td className="numeric">
                {isLoadingMetrics ? '...' :
                 (enhancedMetrics?.Local_Min_Count_2Y !== undefined ?
                  enhancedMetrics.Local_Min_Count_2Y : 'N/A')}
            </td>
            <td>
                {stock.updated_at
                    ? new Date(stock.updated_at).toLocaleString()
                    : '-'}
            </td>
            <td>
                <input
                    type="checkbox"
                    checked={stock.watchlist || false}
                    onChange={handleToggleWatchlist}
                />
            </td>
            <td>
                <button className="delete-btn" onClick={handleRemove}> X </button>
            </td>
        </tr>
    );
};

export default StockRow;